<template>
  <AddAddress />
</template>

<script>
import AddAddress from '../../components/user/AddAddress.vue'
export default {
  components: {
    AddAddress,
  },
}
</script>
